import axios from "axios";
import { inquiryUrl } from "../../utils";

export const fetchInquiry = (inquiryId: string) => {
  return axios.get(inquiryUrl(inquiryId));
};
